import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter as Router, Route } from 'react-router-dom';

ReactDOM.render(
    <Router>
        <Route
            path="/search/"
            render={props => (
                <App {...props} withMap={false} />
            )}
        />
    </Router>,
    document.getElementById("root")
);
